import { ReactElement } from 'react'
import i18n from 'strings/i18n'
import useNotificationCenter from 'hooks/useNotificationCenter'
import { NotificationHeader, NotificationWrapper } from './subcomponents'
import NotificationCard from '../NotificationCard'

const NotificationCenter = (): ReactElement => {
  const { notificationList } = useNotificationCenter()
  return (
    <NotificationWrapper
      data-cy="notification-center"
      data-test="notification-center"
    >
      <NotificationHeader
        as="h2"
        data-cy="notification-center-header"
        data-test="notification-center-header"
        weight="bold"
      >
        {i18n({ notificationCenter: 'headerTitle' })}
      </NotificationHeader>
      {Object.values(notificationList).map(
        (notificationCardAttr) =>
          notificationCardAttr.toBeShown && (
            <NotificationCard
              key={notificationCardAttr.id}
              {...notificationCardAttr}
            />
          )
      )}
    </NotificationWrapper>
  )
}

export default NotificationCenter
